


























































import { Component, Vue, Prop } from 'vue-property-decorator';
import { AuthParams } from '@/models/userdata/authparams';

@Component
export default class LoginForm extends Vue {
  @Prop({ default: () => {} }) onLogin;
  @Prop({ default: new AuthParams() }) authParams;
  @Prop() rememberMe;
  @Prop() errors;
  mounted() {
    //const input = this.$cookies.get("userName")
    //  ? <HTMLInputElement>this.$refs.loginSubmit
    //  : <HTMLInputElement>this.$refs.emailInput;
    // input.focus();
  }
}
